export default __webpack_public_path__ + "static/media/17.d7f4d163.jpg";